import { fromFetch } from 'rxjs/fetch';
import { AuthHeaders } from '../../models/auth-headers';
import { requiredHeaders } from '../../models/required-headers';
import { authwsEnvironment } from './authws-environment';

export function postLogout(authToken: string) {
  return fromFetch(
    new Request(authwsEnvironment.logoutUrl, {
      method: 'POST',
      headers: {
        ...requiredHeaders,
        ...new AuthHeaders(),
      },
      body: JSON.stringify({
        authToken,
      }),
    })
  );
}
